<template>
    <transition name="fade">

        <section>
            <div class="modal fade" id="modalCob" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
                <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title bold">{{doc.label}}</h5>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>First Name</label>
                                        <input type="text" class="form-control form-control-sm text-uppercase" v-model.trim="formCob.fname" @input="formCob.fname=$event.target.value.toUpperCase().trim()" :class="{ 'is-invalid': submitting && $v.formCob.fname.$error }">
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>Middlename</label>
                                        <input type="text" class="form-control form-control-sm text-uppercase" v-model.trim="formCob.mname" @input="formCob.mname=$event.target.value.toUpperCase().trim()" :class="{ 'is-invalid': submitting && $v.formCob.mname.$error }">
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>Lastname</label>
                                        <input type="text" class="form-control form-control-sm text-uppercase" v-model.trim="formCob.lname" @input="formCob.lname=$event.target.value.toUpperCase().trim()" :class="{ 'is-invalid': submitting && $v.formCob.lname.$error }">
                                    </div>
                                </div>

                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="">Suffix</label>
                                        <select class="form-control custom-select-sm" v-model="formCob.suffix_code">
                                            <option :value="null" selected>- Select -</option>
                                            <option value="2020001">I</option>
                                            <option value="2020002">II</option>
                                            <option value="2020003">III</option>
                                            <option value="2020004">SR.</option>
                                            <option value="2020005">JR.</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label for="">Relationship to the Borrower</label>
                                        <v-select append-to-body :calculate-position="withPopper" placeholder="- Select -" label="relation_desc" :class="{'vs-invalid': submitting && $v.formCob.relation_code.$error }" :options="ref_cob_rel" v-model="formCob.relation_code" :reduce="relation_desc => relation_desc.relation_code" :clearable="false">
                                        </v-select>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>Government-Issued ID</label>
                                        <v-select append-to-body :calculate-position="withPopper" placeholder="- Select -" label="id_name" :class="{'vs-invalid': submitting && $v.formCob.id_code.$error }" :options="ref_gov_id" v-model="formCob.id_code" :reduce="id_name => id_name.id_code" :clearable="false">
                                        </v-select>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="">ID Number</label>
                                        <input type="text" class="form-control form-control-sm" @input="formCob.id_number=$event.target.value.toUpperCase().trim()" v-model.trim="formCob.id_number" :class="{ 'is-invalid': submitting && $v.formCob.id_number.$error }">
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label>{{doc.label}}</label>
                                        <div class="input-group">
                                            <input type="file" hidden accept=".png, .jpg, .jpeg, .pdf" id="ref29" @change="$emit('attach', $event)">
                                            <input type="text" v-if="fetchATT.ATT29 || formATT.ATT29" class="form-control form-control-sm ro" @click="browseRef()" readonly :value="doc.details['file']">
                                            <input type="text" v-else class="form-control form-control-sm ro" readonly value="Choose a file.." :class="{'is-invalid': submitting && $v.formATT.ATT29.$error}" @click="browseRef()">
                                            <div class="input-group-append">
                                                <button class="btn btn-sm btn-outline-primary" @click="browseRef()">
                                                    <span v-if="fetchATT.ATT29 || formATT.ATT29 ">Change</span>
                                                    <span v-else>Attach</span>
                                                </button>
                                                <button v-if="fetchATT.ATT29 || formATT.ATT29" class="btn btn-sm btn-outline-primary ml-2" @click="viewATT(formATT.ATT29, doc.label, fetchATT.ATT29)">View</button>
                                            </div>
                                        </div>

                                        <div class="mt-1">
                                            <div class="row">
                                                <div class="col-12">
                                                    <div class="progress" v-if="progress.ATT29">
                                                        <div class="progress-bar progress-bar-striped bg-success" role="progressbar" :style="'width:'+progress.ATT29+ ';'">
                                                            {{progress.ATT29}}
                                                        </div>
                                                    </div>
                                                    <span v-else class="badge" :class="doc.status">{{$parent.attStat(doc.status)}}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div class="modal-footer">
                            <button class="btn btn-outline-primary" data-dismiss="modal">Cancel</button>
                            <button class="btn btn-primary" @click='btnUpdate'>Update</button>
                        </div>
                    </div>
                </div>
            </div>


            <div class="modal fade" id="modalATT29" role="dialog" data-backdrop="static" data-keyboard="false">
                <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title bold">{{attachFile.title}}</h5>
                        </div>
                        <div class="modal-body">
                            <div class="col-12" v-if="attachFile.type=='img'">
                                <img :src="attachFile.url" class="img-fluid" alt="Image">
                            </div>
                            <div class="col-12" v-if="attachFile.type=='pdf'">
                                <object :data="attachFile.url + '#view=FitH'" type="application/pdf" internalinstanceid="9" title="PDF" width="100%" height="678">
                                    <div class="alert alert-warning2" role="alert">
                                        <p>Your browser isn't supporting embedded pdf files. You can download the file.</p>
                                    </div>
                                </object>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button class="btn btn-outline-primary" @click="closeModalATT29"><i class="fas fa-times-circle mr-1"></i>Close</button>
                            <button class="btn btn-outline-primary" @click="downloadATT29(attachFile.url, attachFile.name)"><i class="fas fa-download mr-1"></i>Download</button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </transition>
</template>
<script>
    import {
        createPopper
    } from '@popperjs/core';
    import {
        required,
        requiredIf
    } from 'vuelidate/lib/validators';

    export default {
        props: ['formCob', 'fetchATT', 'formATT', 'progress', 'ref_gov_id', 'attachFile', 'docs', 'ref_gov_id', 'ref_cob_rel'],
        data() {
            return {
                doc: this.docs.find(item => item.code === 'ATT29'),
                submitting: false,

            }
        },
        validations: {
            formCob: {
                fname: {
                    required
                },
                mname: {
                    required
                },
                lname: {
                    required
                },
                relation_code: {
                    required
                },
                id_number: {
                    required
                },
                id_code: {
                    required
                },
            },
            formATT: {
                ATT29: {
                    required: requiredIf(function() {
                        return !this.fetchATT.ATT29;
                    })
                },
            }
        },
        created() {},
        methods: {
            postForm(formData, key) {
                this.$parent.$parent.payloading = true;
                const config = {
                    headers: {
                        'content-type': 'multipart/form-data',
                        'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content,
                    },
                    onUploadProgress: function(progressEvent) {
                        this.progress[key] = parseInt(Math.round((progressEvent.loaded * 100) / progressEvent.total)) + '%';
                    }.bind(this)
                }
                axios.post('/api/v2-post-cob-detail', formData, config)
                    .then(res => {
                        if (res.status === 200) {
                            this.formATT[key] = null;
                            this.progress[key] = 0;

                            $('#modalCob').modal('hide');
                            Fire.$emit('evalRequirement');
                            window.URL.revokeObjectURL(this.attachFile.url);
                            this.attachFile.url = null;

                        }
                        this.$parent.$parent.payloading = false;
                    }).catch(err => {
                        this.$parent.$parent.payloading = false;
                    })
            },
            async submitForm() {
                let key = 'ATT29';
                let formData = new FormData();

                formData.append('borrower_id', this.formCob.borrower_id);
                formData.append('fname', this.formCob.fname);
                formData.append('mname', this.formCob.mname);
                formData.append('lname', this.formCob.lname);
                formData.append('suffix_code', this.formCob.suffix_code);
                formData.append('relation_code', this.formCob.relation_code);
                formData.append('id_number', this.formCob.id_number);
                formData.append('id_code', this.formCob.id_code);

                if (this.formATT[key]) {
                    formData.append('upload_file', this.formATT[key]);
                    formData.append('attach_code', key);
                    this.postForm(formData, key);
                } else {
                    this.postForm(formData, key);
                }

            },

            btnUpdate: _.debounce(function() {
                this.submitting = true;
                this.$v.formATT.$touch();
                this.$v.formCob.$touch();
                if (this.$v.formATT.$invalid || this.$v.formCob.$invalid) {
                    // condition
                } else {
                    this.submitForm();
                }
            }, 333),

            withPopper(dropdownList, component, {
                width,
                top,
                left
            }) {
                dropdownList.style.top = top;
                dropdownList.style.left = left;
                dropdownList.style.width = width;

                const popper = createPopper(component.$refs.toggle, dropdownList, {
                    placement: 'top',
                    modifiers: [{
                            name: 'offset',
                            options: {
                                offset: [0, -1]
                            }
                        },
                        {
                            name: 'toggleClass',
                            enabled: true,
                            phase: 'write',
                            fn({
                                state
                            }) {
                                component.$el.classList.toggle('drop-up', state.placement === 'top')
                            },
                        }
                    ]
                });
                return () => popper.destroy();
            },


            browseRef() {
                document.getElementById('ref29').click();
            },
            viewATT(formATT, title, fetchATT) {
                if (formATT) {
                    $('#modalCob').modal('hide');
                    this.$parent.viewAttachFile(formATT, title, '#modalATT29');
                }
                if (fetchATT) {
                    $('#modalCob').modal('hide');
                    this.$parent.viewFetch(fetchATT, title, '#modalATT29', 2);
                }
            },
            closeModalATT29() {
                window.URL.revokeObjectURL(this.attachFile.url);
                $('#modalATT29').modal('hide');
                for (let k in this.attachFile) {
                    this.attachFile[k] = null;
                }
                $('#modalCob').modal('show');
            },
            downloadATT29(fileURL, name) {
                const link = document.createElement('a');
                link.href = fileURL;
                link.setAttribute('download', name.slice(name.length - 22));
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(fileURL);
            },
        },
        computed: {},
        mounted() {}
    }
</script>



<style scoped>

</style>